import { Controller } from "@hotwired/stimulus"

// Arrow-key navigation between a shareable Response's "Photos" gallery images
// (card #3753), mirroring planning_modal_nav_controller's ArrowLeft/ArrowRight
// behaviour: the chevrons in shareables/image.html.erb are plain links that
// already navigate content_modal_frame on their own, so this only has to
// forward the keystroke to them. Kept as its own controller (rather than
// reusing planning-modal-nav directly) since that one's naming and comments
// are specific to the missions planning modal, even though the logic is
// identical.
//
// Targets are only present when a neighbouring image exists in that
// direction (no wraparound, see ShareablesController#image), so at either
// end of the gallery the key simply does nothing rather than hitting a dead
// control.
export default class extends Controller {
  static targets = ["prev", "next"]

  connect() {
    this.onKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener("keydown", this.onKeyDown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeyDown)
  }

  handleKeyDown(event) {
    const el = event.target
    if (el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName))) return
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return

    if (event.key === "ArrowLeft" && this.hasPrevTarget) {
      event.preventDefault()
      this.prevTarget.click()
    } else if (event.key === "ArrowRight" && this.hasNextTarget) {
      event.preventDefault()
      this.nextTarget.click()
    }
  }
}
